module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-note"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('cardN', {
    attrs: {
      "showBullets": false,
      "showAction": false,
      "columns": 6
    }
  }, [_c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_vm._v("TOC" + _vm._s(_vm.item.toc.id))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_vm._v(_vm._s(_vm.item.toc.name))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_vm._v(_vm._s(_vm.item.status))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_vm._v(_vm._s(_vm.item.signed_on))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_vm._v("Document date")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_vm._v(_vm._s(_vm.item.document_date))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_vm._v("Type")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_vm._v(_vm._s(_vm.item.toc.toc_type.name))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_vm._v(_vm._s(_vm.item.toc.toc_type.group))]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n5"
    },
    slot: "n5"
  }, [_vm._v("Version")]), _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n5"
    },
    slot: "n5"
  }, [_vm._v(_vm._s(_vm.item.document_version))]), (_vm.hasAttachment) ? _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n6"
    },
    slot: "n6"
  }, [_vm._v("Document")]) : _vm._e(), (_vm.hasAttachment) ? _c('div', {
    staticClass: "field-value",
    attrs: {
      "slot": "n6"
    },
    slot: "n6"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-file-pdf-o",
    on: {
      "click": function($event) {
        return _vm.fileUrl()
      }
    }
  })])]) : _vm._e()])], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66cb4b19!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/DriverToc.vue
// module id = 2402
// module chunks = 1